import {type ICategory} from './schema';

export const categoryDefaults: ICategory = {
	ancestors: [],
	assetId: 0,
	assetLabel: '',
	byteCount: '',
	categoryAttributes: [],
	categoryid: 0,
	id: 0,
	children: [],
	contents: '',
	creationDate: '',
	description: '',
	facet: false,
	file: '',
	fileCount: 0,
	hasContents: false,
	moduserlabel: '',
	name: '',
	orderby: 0,
	parentCategoryName: '',
	parentid: 1,
	path: '',
	permissionMatrix: [0, 0, 0, 0, 0, 0],
	recursivePermission: false,
	repositorydirectory: '/',
	subCategoryCount: 0,
	type: 0,
	userId: 0,
	visible: 1,
};
